module.exports = __webpack_public_path__ + "static/media/resonance1b3e5e1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/resonance.svg
// module id = 1338
// module chunks = 0